import React, { FC } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

const AlertDialog: FC<{
  open: boolean;
  onClose: () => void;
  title?: string;
  content?: string;
  buttonTitle: string;
}> = ({ open, onClose, title, content, buttonTitle }) => {
  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth="xs">
      {title && <DialogTitle>{title}</DialogTitle>}
      {content && <DialogContent>{content}</DialogContent>}

      <DialogActions sx={{ padding: "16px" }}>
        <Button variant="outlined" onClick={onClose}>
          {buttonTitle}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
